<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-row>
    <v-col cols="12" sm="12">
      <v-row>
        <v-col class="text-right" >
          <v-btn @click="$router.push({ name: 'area-create' })">Создать район</v-btn>
        </v-col>
      </v-row>
      <v-row align="center">
        <v-col >
          <template v-if="selected.length > 0">
            <v-btn class="mr-3" :disabled="selected.length === 0" outlined>Выбрано: {{ selected.length }}</v-btn>
            <v-menu offset-y left :disabled="selected.length === 0">
              <template v-slot:activator="{ on, attrs }">
                <v-btn outlined
                       :disabled="selected.length === 0"
                       class="pl-0 pr-0"
                       min-width="36"
                       v-bind="attrs"
                       v-on="on">
                  <v-icon>mdi-dots-vertical</v-icon>
                </v-btn>
              </template>
              <v-list>
                <v-list-item @click="changeTimeDialog = true; timeDialogType = 'add'">
                  <v-list-item-title>Увеличить время</v-list-item-title>
                </v-list-item>
                <v-list-item @click="changeTimeDialog = true; timeDialogType = 'sub'">
                  <v-list-item-title>Уменьшить время</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </template>
        </v-col>
        <v-col cols="12" sm="9" class="pt-2">
          <v-slide-group class="text-right">
            <v-slide-item v-for="item in filters.branch.value" :key="item.id">
              <v-chip
                  class="v-btn ml-3"
                  close
                  @click:close="removeBranch(item)"
                  color="#FAFCFF"
                  outlined
                  label
                  text-color="currentColor"
              >
                {{ getBranchNameById(item) }}
              </v-chip>
            </v-slide-item>
          </v-slide-group>
        </v-col>
      </v-row>
      <v-data-table
              no-data-text="Нет районов"
              no-results-text="По заданному запросу ничего не найдено"
              :headers="headers"
              :items="areas"
              v-model="selected"
              :search="search"
              :options.sync="options"
              :header-props="{sortIcon: 'icon-custom-arrow'}"
              :item-class="getItemClass"
              :footer-props="footerProps"
              :fixed-header="true"
              height="60vh"
              :loading="loading"
              show-select
              loading-text="Загрузка районов... Подождите пожалуйста"
      >
        <template v-slot:header.branch>
          Филиал<br>
          <v-btn fab x-small outlined class="filter-button" :class="{active: filters.branch.value.length > 0}"
                 @click.stop.prevent="filters.branch.modal = !filters.branch.modal">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="10" cy="10" r="9.5" fill="white" stroke="#EAF0F6"/>
              <path d="M8.88889 13.6667H11.1111V12.5556H8.88889V13.6667ZM5 7V8.11111H15V7H5ZM6.66667 10.8889H13.3333V9.77778H6.66667V10.8889Z" fill="#B4BDC6"/>
            </svg>
          </v-btn>
        </template>
        <template v-slot:item.delivery_time="{ item }">
          <v-chip
                  class="mr-2 time-chip"
                  label
          >
            {{ item.delivery_time }}
            <v-icon right small dark @click="resetTime(item)">
              mdi-close-circle
            </v-icon>
          </v-chip>
          <span @click="changeTime(item, -5)" class="plus-minus-btn">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" >
              <circle cx="12" cy="12" r="11.5" fill="white" stroke="#EAF0F6"/>
              <rect x="17" y="11" width="2" height="10" transform="rotate(90 17 11)" fill="#B4BDC6"/>
            </svg>
          </span>
          <span @click="changeTime(item, 5)" class="plus-minus-btn">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="12" cy="12" r="11.5" fill="white" stroke="#EAF0F6"/>
              <rect x="11.166" y="7" width="2" height="10" fill="#B4BDC6"/>
              <rect x="17" y="11.166" width="2" height="10" transform="rotate(90 17 11.166)" fill="#B4BDC6"/>
            </svg>
          </span>
        </template>
        <template v-slot:item.min_sum="{ item }">
          {{ item.min_sum }} UAH
        </template>
        <template v-slot:item.branch="{ item }">
          <v-select
                  :items="branches"
                  :item-text="branch => branch.name"
                  :item-value="branch => branch.id"
                  v-model="item.branch"
                  hide-details
                  dense
                  outlined
                  @change="changeBranch(item)"
          ></v-select>
        </template>
        <template v-slot:item.is_disabled="{ item }">
          <v-simple-checkbox @click="toggleDisabled(item)" :value="item.is_disabled"></v-simple-checkbox>
        </template>
        <template v-slot:item.actions="{ item }">
          <div class="text-right">

            <v-menu offset-y>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                        small
                        class="mr-2"
                        v-bind="attrs"
                        v-on="on"
                >
                  mdi-dots-vertical
                </v-icon>
              </template>
              <v-list>
                <v-list-item @click="$router.push({ name: 'area-edit', params: { id: item.id } })">
                  <v-list-item-title>Редактировать</v-list-item-title>
                </v-list-item>
                <v-list-item @click="submitDialog = true; submitItem = item">
                  <v-list-item-title>Удалить</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </div>
        </template>
      </v-data-table>
      <!--</v-card>-->
    </v-col>
    <v-dialog
            v-model="submitDialog"
            max-width="444"
    >
      <v-card>
        <v-card-title >
          Подтвердить действие
        </v-card-title>

        <v-card-actions>


          <v-btn
                  v-if="submitItem == null"
                  @click="submitDelete(submitItem); submitDialog = false">
            Да
          </v-btn>
          <v-btn
                  v-else
                  @click="submitDelete(submitItem); submitDialog = false">
            Да
          </v-btn>
          <v-btn
                  outlined
                  @click="submitDialog = false"
          >
            Нет
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
        v-model="changeTimeDialog"
        max-width="444"
    >
      <v-card>
        <v-card-title >
          {{ timeDialogType == 'add' ? 'Добавить время' : 'Уменьшить время'}}
        </v-card-title>
        <v-card-text>
          <v-text-field
              label="Количество минут"
              outlined
              v-model="timeDialogCount"
          ></v-text-field>
        </v-card-text>
        <v-card-actions>


          <v-btn
              @click="massChangeTime">
            Да
          </v-btn>
          <v-btn
              outlined
              @click="changeTimeDialog = false"
          >
            Нет
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
        v-model="filters.branch.modal"
        max-width="444"
    >
      <v-card>
        <v-card-title >
          Фильтрация
        </v-card-title>
        <v-card-text>
          <v-select
              :items="branches"
              :item-text="branch => branch.name"
              :item-value="branch => branch.id"
              v-model="filters.branch.tempValue"
              label="Филиал"
              :clearable="true"
              outlined
              multiple
              :hide-details="true"
          >
            <template v-slot:selection="{ item, index }">
                  <span v-if="index === 0" class="font-weight-bold">
                    Выбрано: {{ filters.branch.tempValue.length }}
                  </span>
            </template>
          </v-select>
        </v-card-text>
        <v-card-actions>
          <v-btn @click.prevent.stop="setBranchFilter" >Выбрать</v-btn>

          <v-btn
              outlined
              @click="filters.branch.modal = false"
          >
            Нет
          </v-btn>

        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
    // @ is an alias to /src

    import AreaService from '../../../api/AreaService'
    import BranchService from "../../../api/BranchService";
    import ModifierService from "../../../api/ModifierService";

    export default {
        name: 'ProductIndex',
        components: {},
        data: () => ({
          filters: {
            branch: {
              value: [],
              tempValue: [],
              modal: false,
            },
          },
            changeTimeDialog: false,
            timeDialogType: 'add',
            timeDialogCount: null,
            overlay: false,
            search: '',
            loadingModal: false,
            loading: true,
            tab: null,
            submitDialog: false,
            submitItem: null,
            dialog: false,
            selected: [],
            areas: [],
            branches: [],
            options: {},
            area: {
                id: null,
                name: '',
                name_ua: '',
            },
            footerProps: {
                itemsPerPageText: 'Тегов на страницу',
                pageText: '{0}-{1} из {2}',
                itemsPerPageAllText: 'Все',
                itemsPerPageOptions: [-1]
            },
            totalProducts: 0,
            headers: [
                {
                    text: 'Название',
                    value: 'name',
                  sortable: false,
                },
                {
                    text: 'Кол-во',
                    value: 'streets_count',
                  sortable: false,
                },
                {
                    text: 'Время доставки',
                    value: 'delivery_time',
                  sortable: false,
                },
                {
                  text: 'Выключен',
                  value: 'is_disabled',
                  sortable: false,
                },
                {
                  text: 'Мин. сумма',
                  value: 'min_sum',
                  sortable: false,
                },
                {
                  text: 'Филиал',
                  value: 'branch',
                  sortable: false,
                },
                {text: 'Действия', value: 'actions', sortable: false, width: "5%"},
            ],
        }),
        mounted() {
          BranchService.list().then(response => {
              this.branches = response.data
          })
        },
        watch: {
            options: {
                handler() {
                    this.getDataFromApi()
                },
                deep: true,
            },
            "filters.branch.value": {
              handler() {
                this.getDataFromApi()
              },
              deep: true,
            },
        },
        methods: {
          getBranchNameById(id){
            return this.branches.find(branch => branch.id == id).name;
          },
          removeBranch(id){
            this.filters.branch.tempValue.splice(this.filters.branch.tempValue.indexOf(this.filters.branch.tempValue.find(branch => branch.id == id)) - 1, 1);
            this.setBranchFilter()

          },
          setBranchFilter(e) {
            this.filters.branch.value = this.filters.branch.tempValue
            this.filters.branch.modal = false;
            this.overlay = false;
          },
          massChangeTime(){
              let _this = this
              _this.changeTimeDialog = false;
              _this.loading = true
              this.selected.forEach(function (value) {
                  if(_this.timeDialogType == 'add'){
                    _this.changeTime(value, _this.timeDialogCount)
                  } else {
                    _this.changeTime(value, -(_this.timeDialogCount))
                  }
              })
            _this.loading = false
          },
          submitDelete(item = null){
            if(item){
              this.removeArea(item)
            } else {
              //this.massDelete()
            }
          },
          resetTime(item){
            AreaService.update({
              id: item.id,
              delivery_time: item.default_delivery_time
            }).then(response => {
              item.delivery_time = response.data.delivery_time
            })
          },
          toggleDisabled(item){
            item.is_disabled = !item.is_disabled
            AreaService.update({
              id: item.id,
              is_disabled: item.is_disabled
            }).then(response => {
              item.is_disabled = response.data.is_disabled
            })
          },
            changeTime(item, time){
              AreaService.update({
                id: item.id,
                change_time: time
              }).then(response => {
                  item.delivery_time = response.data.delivery_time
              })
            },
            getItemClass(item){
              if(item.delivery_time != item.default_delivery_time){
                return 'changed-row'
              }
            },
            changeBranch(item){
              AreaService.update({
                id: item.id,
                branch_id: item.branch
              })
            },
            removeArea(item){
              AreaService.remove(item.id).then(response => {
                  this.loading = true
                  this.getDataFromApi()
              })
            },
            createArea(){
                this.loadingModal = true;
                AreaService.create(this.area).then(response => {
                    this.getDataFromApi();
                    this.loadingModal = false;
                })
            },
            updateArea(){
                this.loadingModal = true;
                AreaService.update(this.area).then(response => {
                    this.getDataFromApi();
                    this.loadingModal = false;
                })
            },
            getDataFromApi() {
                this.loading = true
              this.selected = [];

              let params = {
                branches: this.filters.branch.value,
              }

                AreaService.list(params)
                    .then(response => {
                        this.areas = response.data
                        this.loading = false
                    })
            },
        }
    }
</script>

<style>
  .changed-row{
    background-color: #FFEEEC;
  }
</style>

<style lang="scss" scoped>
  .v-btn--fab.v-size--x-small {
    width: 20px;
    height: 20px;

    .mdi::before {
      font-size: 12px;
    }
  }
  span.v-btn{
    border-color: currentColor!important;
  }

  .filter-popup {
    position: absolute;
    width: 250px;
    z-index: 5;

    &:hover {
      cursor: auto;
    }



    &.v-card--link:focus::before {
      opacity: 0;
    }
  }
</style>
